import MuiButton from 'components/common/button/MuiButton';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import React from 'react';
import styled from 'styled-components';

interface ProjectOptionButtonProps {
  onLibraryClick: () => void;
}

const ProjectOptionButton = ({ onLibraryClick }: ProjectOptionButtonProps) => {
  return (
    <StyledProjectOptionButton>
      <div className="projectOption__title">
        <CustomText fontSize={20} fontWeight={600} fontColor="#222">
          <T>GLOBAL_LIBRARY</T>
        </CustomText>
      </div>
      <div className="projectOption__content">
        <MuiButton fullWidth disableElevation variant="outlined" onClick={onLibraryClick}>
          <T>PROJECT_SELECT_LIBRARY</T>
        </MuiButton>
      </div>
    </StyledProjectOptionButton>
  );
};

const StyledProjectOptionButton = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  .projectOption__title {
    width: 163px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .projectOption__content {
    display: flex;
    width: 100%;
  }
`;

export default ProjectOptionButton;
